import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AboutThisCar from "./component";
import { setPreApprovedOrigin } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { getPreApprovalLoanDetails } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";

const mapStateToProps = ({
    carDetails: {
        content,
        eligibleForExtendedWarranty,
        userDeliveryState,
        config,
        oldTimerBanner,
        isFetchingFromCarCard
    },
    checkout: {extendedWarranty: { warrantyPlanInfo }},
    user: {
        isLoggedIn

    },
    deliveryInfo,
    preApprovalLoan: {
        preApproved,
        maxPermissibleRepaymentPerWeek,
        firstName,
        absolutePermissibleLoanAmount
    }

}) => ({
    content,
    warrantyPlanInfo,
    eligibleForExtendedWarranty,
    isLoggedIn,
    userDeliveryState,
    deliveryInfo,
    config,
    oldTimerBanner,
    preApproved,
    firstName,
    maxPermissibleRepaymentPerWeek,
    absolutePermissibleLoanAmount,
    isFetchingFromCarCard
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setPreApprovedOriginConnect: setPreApprovedOrigin,
    getPreApprovalLoanDetailsConnect: getPreApprovalLoanDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AboutThisCar);
